import Axios from "axios";
import { AppSettings } from "../types/appSettings";

export class AppSettingsApi {
  static async GetAppSettings(): Promise<AppSettings> {
    try {
      const response = await Axios.get<AppSettings>("./api/appsettings");
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
